export default __webpack_public_path__ + "b5f0f109bc88052d4000c58ca615671d.woff2";